import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import { Navbar, NavbarNav, NavItem, SideNavLink, Fa, SideNavNav, SideNav } from 'mdbreact';
import PageHome from './Pages/Home/page-home';
import PagePhoto from './Pages/Photo/page-photo';
import PageDrawing from './Pages/Drawing/page-drawing';
import PageVideo from './Pages/Video/page-video';
import PageArchitecture from './Pages/Architecture/page-architecture';

import './jd-main.css';


import image_jd_logo from 'assets/logo/jd-logo.png';
import image_side_nav from 'assets/logo/sidenav1.jpg';


const g_pageTitleHome = 'Home';
const g_pageTitlePhoto = 'Photo';
const g_pageTitleVideo = 'Video';
const g_pageTitleDrawing = 'Drawing';
const g_pageTitleArchitecture = 'Architecture';

class DoubleNavigationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleStateA: false,
      breakWidth: 1300,
      windowWidth: 0,
      textActivePageTitle: 'JD'
    };
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => this.setState({
    windowWidth: window.innerWidth
  });

  handleToggleClickA = () => {
    this.setState({
      toggleStateA: !this.state.toggleStateA
    });
  }

  handleToggleClickMenuItemHome = (param) => { // eslint-disable-line no-unused-vars
    console.log('handleToggleClickMenuItemHome');
  }

  handleToggleClickMenuItemPhoto = (param) => { // eslint-disable-line no-unused-vars
    console.log('handleToggleClickMenuItemPhoto');
  }

  handleToggleClickMenuItemDrawing = (param) => { // eslint-disable-line no-unused-vars
    console.log('handleToggleClickMenuItemDrawing');
  }

  onActivePageActivated = (param) => {
    console.log('DoubleNavigationPage::onActivePageActivated');
    console.log(param);
    this.setState({ textActivePageTitle: param });
  }

  JDHomePage = (props) => {
    return (
      <PageHome
        propTitle={g_pageTitleHome}
        onActivated={this.onActivePageActivated.bind(this)}
        {...props}
      />
    );
  }

  JDPhotoPage = (props) => {
    return (
      <PagePhoto
        propTitle={g_pageTitlePhoto}
        onActivated={this.onActivePageActivated.bind(this)}
        {...props}
      />
    );
  }

  JDDrawingPage = (props) => {
    return (
      <PageDrawing
        propTitle={g_pageTitleDrawing}
        onActivated={this.onActivePageActivated.bind(this)}
        {...props}
      />
    );
  }

  JDVideoPage = (props) => {
    return (
      <PageVideo
        propTitle={g_pageTitleVideo}
        onActivated={this.onActivePageActivated.bind(this)}
        {...props}
      />
    );
  }

  JDArchitecturePage = (props) => {
    return (
      <PageArchitecture
        propTitle={g_pageTitleArchitecture}
        onActivated={this.onActivePageActivated.bind(this)}
        {...props}
      />
    );
  }

  render() {
    const navStyle = { paddingLeft: this.state.windowWidth > this.state.breakWidth ? '210px' : '16px' };
    const mainStyle = { margin: '0 6%', paddingTop: '5.5rem', paddingLeft: this.state.windowWidth > this.state.breakWidth ? '240px' : '0' };
    return (
      <Router>
        <div className="fixed-sn light-blue-skin">
          <SideNav
            logo={image_jd_logo}
            triggerOpening={this.state.toggleStateA}
            breakWidth={this.state.breakWidth}
            bg={image_side_nav}
            mask="strong"
          >

            <SideNavNav>

              <SideNavLink to="/" exact className="pl-5 text-left pr-5">
                <Fa icon=" fa-home" className="d-inline-inline"/> Home
              </SideNavLink>
              <SideNavLink to="/architecture" className="pl-5 text-left pr-5">
                <Fa icon=" fa-building" className="d-inline-inline"/> Architecture
              </SideNavLink>
              <SideNavLink to="/drawing" className="pl-5 text-left pr-5">
                <Fa icon=" fa-paint-brush" className="d-inline-inline"/> Drawing
              </SideNavLink>
              <SideNavLink to="/photo" className="pl-5 text-left pr-5" >
                <Fa icon=" fa-file-photo-o" className="d-inline-inline"/> Photo
              </SideNavLink>

            </SideNavNav>
          </SideNav>
          <Navbar style={navStyle} double expand="md" fixed="top" scrolling>
            <NavbarNav left>
              <NavItem>
                <div onClick={this.handleToggleClickA} key="sideNavToggleA" style={{ lineHeight: '32px', marginRight: '1em', verticalAlign: 'middle' }}><Fa icon="bars" color="white" size="2x" /></div>
              </NavItem>
              <NavItem className="d-none d-md-inline" style={{ paddingTop: 5 }}>
                {this.state.textActivePageTitle}
              </NavItem>
            </NavbarNav>

          </Navbar>
          <main style={mainStyle}>
            <Switch>
              <Route exact path='/' render={this.JDHomePage}/>
              <Route exact path='/home' render={this.JDHomePage}/>
              <Route path='/photo' render={this.JDPhotoPage}/>
              <Route path='/drawing' render={this.JDDrawingPage}/>
              <Route path='/video' render={this.JDVideoPage}/>
              <Route path='/architecture' render={this.JDArchitecturePage}/>
            </Switch>
          </main>
        </div>
      </Router>
    );
  }
}

export default DoubleNavigationPage;



// WEBPACK FOOTER //
// ./src/jd-main.js